
























































































































































































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { AutoApprovalParams } from '@/interfaces/server-data';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';

@Component({
  name: 'AutoApprovalParametersForm',
  components: {
    SwitchWithLabel,
  },
})
export default class AutoApprovalParametersForm extends Vue {
  @Prop({ type: Object, required: true })
  value!: AutoApprovalParams;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  // Показывать ли поле PI (только для модулей KVI)
  @Prop({ type: Boolean, default: false })
  showPiPercentage!: boolean;

  localParams: AutoApprovalParams = { ...this.value };
  errors: {[key: string]: string} = {};

  @Watch('value', { deep: true })
  onValueChange(newValue: AutoApprovalParams) {
    this.localParams = { ...newValue };
    this.validateAllFields();
  }

  @Emit('input')
  emitInput(params: AutoApprovalParams): AutoApprovalParams {
    return params;
  }

  @Emit('change')
  emitChange(params: AutoApprovalParams): AutoApprovalParams {
    return params;
  }

  @Emit('validation-change')
  emitValidationChange(isValid: boolean): boolean {
    return isValid;
  }

  onParamsChange() {
    this.validateAllFields();
    this.emitInput(this.localParams);
    this.emitChange(this.localParams);
    this.emitValidationChange(this.isValid);
  }

  validateField(fieldName: string) {
    switch (fieldName) {
      case 'priceChange':
        delete this.errors.priceChange;
        if (this.localParams.priceChangeFrom !== null && this.localParams.priceChangeFrom !== undefined) {
          if (this.localParams.priceChangeFrom < -100) {
            this.errors.priceChange = this.$t('regular.autoApproval.priceLowerBoundMin') as string;
          }
        }
        if (this.localParams.priceChangeTo !== null && this.localParams.priceChangeTo !== undefined) {
          if (this.localParams.priceChangeTo < -100) {
            this.errors.priceChange = this.$t('regular.autoApproval.priceUpperBoundMin') as string;
          }
        }
        if (this.localParams.priceChangeFrom !== null && this.localParams.priceChangeFrom !== undefined &&
            this.localParams.priceChangeTo !== null && this.localParams.priceChangeTo !== undefined &&
            this.localParams.priceChangeFrom > this.localParams.priceChangeTo) {
          this.errors.priceChange = this.$t('regular.autoApproval.lowerCannotExceedUpper') as string;
        }
        break;

      case 'marginChange':
        delete this.errors.marginChange;
        if (this.localParams.marginChangeFrom !== null && this.localParams.marginChangeFrom !== undefined) {
          if (this.localParams.marginChangeFrom > 100) {
            this.errors.marginChange = this.$t('regular.autoApproval.marginLowerBoundMax') as string;
          }
        }
        if (this.localParams.marginChangeTo !== null && this.localParams.marginChangeTo !== undefined) {
          if (this.localParams.marginChangeTo > 100) {
            this.errors.marginChange = this.$t('regular.autoApproval.marginUpperBoundMax') as string;
          }
        }
        if (this.localParams.marginChangeFrom !== null && this.localParams.marginChangeFrom !== undefined &&
            this.localParams.marginChangeTo !== null && this.localParams.marginChangeTo !== undefined &&
            this.localParams.marginChangeFrom > this.localParams.marginChangeTo) {
          this.errors.marginChange = this.$t('regular.autoApproval.lowerCannotExceedUpper') as string;
        }
        break;

      case 'profitability':
        delete this.errors.profitability;
        if (this.localParams.profitabilityFrom !== null && this.localParams.profitabilityFrom !== undefined) {
          if (this.localParams.profitabilityFrom > 100) {
            this.errors.profitability = this.$t('regular.autoApproval.profitabilityLowerBoundMax') as string;
          }
        }
        if (this.localParams.profitabilityTo !== null && this.localParams.profitabilityTo !== undefined) {
          if (this.localParams.profitabilityTo > 100) {
            this.errors.profitability = this.$t('regular.autoApproval.profitabilityUpperBoundMax') as string;
          }
        }
        if (this.localParams.profitabilityFrom !== null && this.localParams.profitabilityFrom !== undefined &&
            this.localParams.profitabilityTo !== null && this.localParams.profitabilityTo !== undefined &&
            this.localParams.profitabilityFrom > this.localParams.profitabilityTo) {
          this.errors.profitability = this.$t('regular.autoApproval.lowerCannotExceedUpper') as string;
        }
        break;

      case 'pi':
        delete this.errors.pi;
        if (this.showPiPercentage) {
          if (this.localParams.piFrom !== null && this.localParams.piFrom !== undefined) {
            if (this.localParams.piFrom < 0) {
              this.errors.pi = this.$t('regular.autoApproval.piLowerBoundMin') as string;
            }
          }
          if (this.localParams.piTo !== null && this.localParams.piTo !== undefined) {
            if (this.localParams.piTo < 0) {
              this.errors.pi = this.$t('regular.autoApproval.piUpperBoundMin') as string;
            }
          }
          if (this.localParams.piFrom !== null && this.localParams.piFrom !== undefined &&
              this.localParams.piTo !== null && this.localParams.piTo !== undefined &&
              this.localParams.piFrom > this.localParams.piTo) {
            this.errors.pi = this.$t('regular.autoApproval.lowerCannotExceedUpper') as string;
          }
        }
        break;
    }
  }

  validateAllFields() {
    this.validateField('priceChange');
    this.validateField('marginChange');
    this.validateField('profitability');
    this.validateField('pi');
    
    const hasAnyParameter = 
      (this.localParams.priceChangeFrom !== null && this.localParams.priceChangeFrom !== undefined) ||
      (this.localParams.priceChangeTo !== null && this.localParams.priceChangeTo !== undefined) ||
      (this.localParams.marginChangeFrom !== null && this.localParams.marginChangeFrom !== undefined) ||
      (this.localParams.marginChangeTo !== null && this.localParams.marginChangeTo !== undefined) ||
      (this.localParams.profitabilityFrom !== null && this.localParams.profitabilityFrom !== undefined) ||
      (this.localParams.profitabilityTo !== null && this.localParams.profitabilityTo !== undefined) ||
      (this.showPiPercentage && (
        (this.localParams.piFrom !== null && this.localParams.piFrom !== undefined) ||
        (this.localParams.piTo !== null && this.localParams.piTo !== undefined)
      ));
    
    if (!hasAnyParameter && !this.localParams.revaluationEfficiencyCheck) {
      this.errors.general = this.$t('regular.autoApproval.mustSetParam') as string;
    } else {
      delete this.errors.general;
    }
  }

  getFieldState(fieldName: string): boolean | null {
    if (this.errors[fieldName]) {
      return false;
    }
    return null;
  }

  get isValid(): boolean {
    return Object.keys(this.errors).length === 0;
  }

  get hasErrors(): boolean {
    return Object.keys(this.errors).length > 0;
  }

  // Метод для внешнего вызова валидации
  validateAndShowErrors(): boolean {
    this.validateAllFields();
    return this.isValid;
  }
}
